import { render, staticRenderFns } from "./dataDetails.vue?vue&type=template&id=13574b38&scoped=true"
import script from "./dataDetails.vue?vue&type=script&lang=js"
export * from "./dataDetails.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/styles/introduce-common.scss?vue&type=style&index=0&id=13574b38&prod&lang=scss&scoped=true&external"
import style1 from "./dataDetails.vue?vue&type=style&index=1&id=13574b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13574b38",
  null
  
)

export default component.exports